import BaseService from "../BaseService";
import _ from "lodash";

class SignupService extends BaseService {
    getProducts = async (info) => {
        var data = await this._api.post("sampledata/products", info);
        return data;
    }







}
export default SignupService;
